import { createFileRoute, redirect } from '@tanstack/react-router';

import { hasFeature } from '@/features/feature-flags';
import { FEATURES } from '@/features/feature-flags/feature-flags.constants';
import { JournalScreen } from '@/features/journal/journal-screen-v2';
import { littlebirdSdk } from '@/lib/sdk-init';
import { Routes } from '@/types/routes';

export const Route = createFileRoute('/_authenticated/journal/')({
  beforeLoad() {
    if (hasFeature(FEATURES.JOURNALS)) {
      return;
    }

    throw redirect({
      to: Routes.Chats as string,
      replace: true,
    });
  },
  onEnter() {
    void littlebirdSdk.stores.journals.ensureListLoadedFromStorage();
  },
  component: JournalScreen,
});
